<template>
  <GenericCard
    :locked="locked"
    :on-action="submitForm"
    title="Personal Overview"
    :view-only="viewOnly"
  >
    <v-form
      :disabled="locked"
      @submit.prevent="submitForm"
    >
      <v-row>
        <!-- experienced_labor_violation_us -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="experienced_labor_violation_us">Experienced labor violation in US?</label>
          <v-row>
            <v-checkbox
              v-model="section.experienced_labor_violation_us"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.experienced_labor_violation_us"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.experienced_labor_violation_us"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- fear_returning_home_country -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="fear_returning_home_country">Fear of returning to home country?</label>
          <v-row>
            <v-checkbox
              v-model="section.fear_returning_home_country"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.fear_returning_home_country"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.fear_returning_home_country"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- forced_sexual_encounters -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="forced_sexual_encounters">Forced sexual encounters?</label>
          <v-row>
            <v-checkbox
              v-model="section.forced_sexual_encounters"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.forced_sexual_encounters"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.forced_sexual_encounters"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- forced_to_work_against_will -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="forced_to_work_against_will">Forced to work against will?</label>
          <v-row>
            <v-checkbox
              v-model="section.forced_to_work_against_will"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.forced_to_work_against_will"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.forced_to_work_against_will"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- hrifa_eligibility -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="hrifa_eligibility">HRIFA (Haiti) eligibility?</label>
          <v-row>
            <v-checkbox
              v-model="section.hrifa_eligibility"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.hrifa_eligibility"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.hrifa_eligibility"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- mistreated_by_coyote_in_transit -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="mistreated_by_coyote_in_transit">Mistreated by coyote or guide in transit to or in US?</label>
          <v-row>
            <v-checkbox
              v-model="section.mistreated_by_coyote_in_transit"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.mistreated_by_coyote_in_transit"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.mistreated_by_coyote_in_transit"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- nacara_eligibility -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="nacara_eligibility">NACARA eligibility?</label>
          <v-row>
            <v-checkbox
              v-model="section.nacara_eligibility"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.nacara_eligibility"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.nacara_eligibility"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- national_of_tps_designated_country -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="national_of_tps_designated_country">National of TPS designated country?</label>
          <v-row>
            <v-checkbox
              v-model="section.national_of_tps_designated_country"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.national_of_tps_designated_country"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.national_of_tps_designated_country"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- suffered_mental_harm -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="suffered_mental_harm">Suffered mental harm in home country?</label>
          <v-row>
            <v-checkbox
              v-model="section.suffered_mental_harm"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.suffered_mental_harm"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.suffered_mental_harm"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- suffered_physical_harm_home_country -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="suffered_physical_harm_home_country">Suffered physical harm in home country?</label>
          <v-row>
            <v-checkbox
              v-model="section.suffered_physical_harm_home_country"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.suffered_physical_harm_home_country"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.suffered_physical_harm_home_country"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- us_military_service -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="us_military_service">US military service?</label>
          <v-row>
            <v-checkbox
              v-model="section.us_military_service"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.us_military_service"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.us_military_service"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- victim_of_dv_abuse_by_relative_childhood -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="victim_of_dv_abuse_by_relative_childhood">Victim of DV/abuse/abandonment/neglect by a parent during childhood?</label>
          <v-row>
            <v-checkbox
              v-model="section.victim_of_dv_abuse_by_relative_childhood"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.victim_of_dv_abuse_by_relative_childhood"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.victim_of_dv_abuse_by_relative_childhood"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- victim_of_dv_us_usc_relative -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="victim_of_dv_us_usc_relative">Victim of DV in US by USC/LPR parent, spouse?</label>
          <v-row>
            <v-checkbox
              v-model="section.victim_of_dv_us_usc_relative"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.victim_of_dv_us_usc_relative"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.victim_of_dv_us_usc_relative"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>

        <!-- victim_of_ucrime_us -->
        <v-col
          cols="auto"
          md="4"
        >
          <label for="victim_of_ucrime_us">Victim of potentially U-qualifying crime in US?</label>
          <v-row>
            <v-checkbox
              v-model="section.victim_of_ucrime_us"
              label="No"
              :true-value="0"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.victim_of_ucrime_us"
              label="Yes"
              :true-value="1"
              :false-value="null"
              hide-details
              class="px-4"
            />
            <v-checkbox
              v-model="section.victim_of_ucrime_us"
              label="Unknown"
              :true-value="-1"
              :false-value="null"
              hide-details
              class="px-4"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea
            v-model="section.notes"
            label="Notes"
            rows="4"
            outlined
          />
        </v-col>
      </v-row>
    </v-form>
  </GenericCard>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import { alertHandler } from '@/alertHandler'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericCard from '@/components/Party/PartyEdit/SectionCards/GenericCard.vue'

export default {
  name: 'PersonalOverviewCard',
  components: { GenericCard },

  props: {
    item: {
      required: true,
      type: Object,
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      section: {},
    }
  },

  computed: {
    locked: {
      get () {
        return this.PePersonalOverviewCardLock
      },

      set (value) {
        this.setPePersonalOverviewCardLock(value)
      },
    },

    viewOnly () {
      return this.$store.getters['partyEdit/viewOnly']
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'PePersonalOverviewCardLock',
    ]),
  },

  watch: {
    item: {
      immediate: true,

      handler: function () {
        this.section = { ...this.item }
      },

      deep: true,
    },
  },

  created () {
    this.initPePersonalOverviewCard()
  },

  methods: {
    async onCardUpdate () {
      return this.PePersonalOverviewCardUpdate({ id: this.id, section: this.section })
    },

    async onSectionUnlock () {
      return this.setPePersonalOverviewCardLock(false)
    },

    async submitForm () {
      if (this.locked) return this.onSectionUnlock()
      else return this.onCardUpdate()
    },

    ...mapMutations(PARTY_NAMESPACE, [
      'setPePersonalOverviewCardLock',
    ]),

    ...mapActions(PARTY_NAMESPACE, [
      'PePersonalOverviewCardUpdate',
      'initPePersonalOverviewCard',
    ]),
  },
}
</script>
